// extracted by mini-css-extract-plugin
export var modules = "modules-module--modules--033b5";
export var modules__bage = "modules-module--modules__bage--956de";
export var modules__description = "modules-module--modules__description--69ffd";
export var modules__result = "modules-module--modules__result--17dfc";
export var modules__resultDescr = "modules-module--modules__result-descr--d4142";
export var modules__resultItem = "modules-module--modules__result-item--781f5";
export var modules__resultList = "modules-module--modules__result-list--b4f9a";
export var modules__resultTitle = "modules-module--modules__result-title--8431c";
export var modules__subtitle = "modules-module--modules__subtitle--03283";
export var modules__title = "modules-module--modules__title--c5b43";